import { ofType } from 'redux-observable';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { getCalenderEventsSummary } from 'actions/other';
import TRADE from 'actionTypes/trade';
import { toUTC } from 'helpers/day';

const getOptionsExpiriesCalenderEventsEpic = action$ =>
  action$.pipe(
    ofType(TRADE.GET_OPTIONS_INFO.SUCCESS),
    map(action =>
      action.result.result
        .flatMap(item => item.data)
        .flatMap(item => item.settlement_time)
        .sort()
    ),
    filter(sortedExpiries => sortedExpiries.length),
    map((sortedExpiries: string[]) => {
      const startDate = toUTC(sortedExpiries[0]).startOf('day').toISOString();
      const endDate = toUTC(sortedExpiries[sortedExpiries.length - 1])
        .endOf('day')
        .toISOString();

      return {
        startDate,
        endDate,
      };
    }),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    map(({ startDate, endDate }) => {
      return getCalenderEventsSummary({
        startDate,
        endDate,
      });
    })
  );

export { getOptionsExpiriesCalenderEventsEpic };
